import React from "react";
import BlogEditarMiPerfil from "../../components/blogs/BlogDetails/BlogEditarMiPerfil";
import Footer from "../../components/layout/footer/Footer";
import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";
import PageHeader from "../../components/team/PageHeader";

export default function HelpCreatorComoEditarMiPefil() {
  return (
    <Layout>
      <Navbar darkBg />
      <PageHeader
        HeaderTitle="Como editar mi Perfil"
        PageTitle="Como editar mi Perfil"
        Parent="Ayuda"
      />
      <BlogEditarMiPerfil />
      <Footer />
    </Layout>
  );
}